/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React from "react";
import { useRefToSetFocus } from "containers/accessibility/AccessibleFocusableNodeContainers";
import accessibilityStyles from "./Accessibility.css";
import { a11yClasses } from "constants/enums";

export const AccessibleMarkupCommentNode = ({
  style,
  annotInfo: { annotationType, annotContent },
  onClick,
  onFocus,
  shouldFocus,
  textContent,
  resetShouldFocus
}) => {
  const ref = useRefToSetFocus(shouldFocus, resetShouldFocus);
  const beginAnnotStr = `begin ${annotationType}${annotContent ? " with comment" : ""}`;
  const endAnnotStr = `end ${annotationType}`;
  return (
    <button
      onClick={onClick}
      style={style}
      className={`${accessibilityStyles.commentButton} ${a11yClasses.A11Y_COMMENT}`}
      onFocus={onFocus}
      ref={ref}
    >
      <span>{beginAnnotStr}</span>, {textContent}, <span>{endAnnotStr}</span>
    </button>
  );
};
